import { render } from "./NoAction.vue?vue&type=template&id=010b11b8&scoped=true"
import script from "./NoAction.vue?vue&type=script&lang=js"
export * from "./NoAction.vue?vue&type=script&lang=js"

import "./NoAction.vue?vue&type=style&index=0&id=010b11b8&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010b11b8"]])

export default __exports__